export default __webpack_public_path__ + "static/7-7170827a1ef142d3bd27d86b11899873.webp";